module.exports = __webpack_public_path__ + "static/media/3rd-prize-spread.e3e3e8b0.png";